<div id="wrapper" class="clearfix">
    <lib-chef-header [options]="headerOptions" [activeRoute]="activeRoute" (onLogout)="doLogout()" (onRouteChange)="changeRoute($event)"></lib-chef-header>
    <section id="content">
        <div class="content-wrap py-0">
            <div class="section bg-white my-0 py-0">
                <div *ngIf="isAccountDeactivated" class="activate-user-info-section text-center">
                    <p class="my-auto">
                        Your subscription is currently cancelled. <a href="javascript:void(0)" (click)="reactivateUser()">Reactivate Account</a>
                    </p>
                </div>
                <div *ngIf="!isAccountDeactivated && showPageNotification" class="activate-user-info-section text-center">
                    <p class="my-auto">
                        {{showPageNotification}}
                    </p>
                </div>
                <!-- <div class="container"> -->
                    <router-outlet></router-outlet>
                <!-- </div> -->
            </div>
        </div>
    </section>
    <lib-chef-loader [options]="loaderOptions"></lib-chef-loader>
    <app-back-to-top></app-back-to-top>
    <lib-chef-footer [options]="footerOptions"></lib-chef-footer>
</div>
